import React from "react";
import { Modal, ModalDialog, DialogTitle, DialogContent, Stack, FormLabel, FormControl, Input, Button, Typography } from "@mui/joy";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { loadDocument } from "../../Document/documentSlice";

export default function FileCopyModal({ open, setOpen, fileTitle, fileId, handleSaveFile }) {
  const dispatch = useDispatch();
  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
  const user = useSelector((state) => state.user);
  const [hasConfirmedSave, setHasConfirmedSave] = React.useState(false)
  
  React.useEffect(() => {
    setHasConfirmedSave(false)
  }, [open])
  
  const SaveDialogue = () => {
    return (
      <ModalDialog>
        <DialogTitle sx={{ justifyContent: "center"}}>Save <b>{fileTitle}</b>?</DialogTitle>
        <DialogContent >
          <Stack spacing={4} mt={4}>
            <Typography>
              If not current changes to the document will be lost.
            </Typography>
            <Stack direction={"row"} justifyContent={"space-between"} spacing={2} >
              <Button variant="outlined" onClick={() => setHasConfirmedSave(true)} color="danger">Discard Changes</Button>
              <Button  onClick={() => { setHasConfirmedSave(true); handleSaveFile(); }}>Save</Button>
            </Stack>
          </Stack>
        </DialogContent>
      </ModalDialog>
    )
  }

  const CopyDialogue = () => {
    const [fileName, setFileName] = React.useState(fileTitle)
    React.useEffect(() => {
      setFileName(fileTitle)
    }, [fileId, fileTitle])
    async function copyDocument() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${user.token}`,
        },
      };
      try {
        const response = await axios.post(
          apiEndpoint + `/document/${fileId}/copy/`,
          { title: fileName },
          config,
        );
        console.log(response);
        dispatch(loadDocument(response.data));
      } catch (error) {
        console.log(error);
      }
    }

    const handleConfirmCopy = () => {
      copyDocument();
      setOpen(false);
    }
    return (
      <ModalDialog>
        <DialogTitle sx={{ justifyContent: "center"}}>Make a copy of <b>{fileTitle}</b>?</DialogTitle>
        <DialogContent >
          <Stack spacing={4} mt={4}>
            <FormControl>
              <FormLabel>Filename</FormLabel>
              <Input value={fileName} onChange={(e) => setFileName(e.target.value)} error={fileName.length === 0} />
            </FormControl>
            <Stack direction={"row"} justifyContent={"space-between"} spacing={2} >
              <Button variant="outlined" onClick={() => setOpen(false)} color="danger">Cancel</Button>
              <Button onClick={() => handleConfirmCopy()}>Copy</Button>
            </Stack>
          </Stack>
        </DialogContent>
      </ModalDialog>
    )
  }


  return fileId ? (
    <React.Fragment>
      <Modal open={open} onClose={() => setOpen(false)}>
        {!hasConfirmedSave ? <SaveDialogue /> : <CopyDialogue />}
      </Modal>
    </React.Fragment>
  ) : (null)
}
